import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from './modal.component';
import { ModalService } from './modal.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
@NgModule({
	declarations: [ModalComponent],
	imports: [ CommonModule, MatTooltipModule, MatCheckboxModule, FormsModule, ReactiveFormsModule ],
	exports: [ModalComponent],
	providers: [ModalService]
})
export class ModalModule {}
